var _path, _path2, _path3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0283 4.12256C12.3392 4.12256 8.52834 7.93339 8.52834 12.6226V16.7167C8.52834 17.5809 8.16 18.8984 7.72084 19.6351L6.09167 22.3409C5.08584 24.0126 5.78 25.8684 7.62167 26.4917C13.7275 28.5317 20.315 28.5317 26.4208 26.4917C28.135 25.9251 28.8858 23.8992 27.9508 22.3409L26.3217 19.6351C25.8967 18.8984 25.5283 17.5809 25.5283 16.7167V12.6226C25.5283 7.94756 21.7033 4.12256 17.0283 4.12256Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6492 4.53329C17.936 4.04538 16.1207 4.04538 14.4075 4.53329C14.8183 3.48496 15.8383 2.74829 17.0283 2.74829C18.2183 2.74829 19.2383 3.48496 19.6492 4.53329V4.53329Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2783 27.0017C21.2783 29.3392 19.3658 31.2517 17.0283 31.2517C15.8667 31.2517 14.79 30.77 14.025 30.005C13.2291 29.2079 12.7809 28.1282 12.7783 27.0017",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 7,
    r: 5,
    fill: "#FF0000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.868d0d5c9bd867fbdd86f6f2593bf0dd.svg";
export { ForwardRef as ReactComponent };